import { UIComponents } from '@sheets-editor/core';
import InlinePlaceholder from './InlinePlaceholder';
import BlockPlaceholder from './BlockPlaceholder';
import VoidBlock from './VoidBlock';
import Button from './Button';
import Popover from './Popover';
import TextField from './TextField';
import MenuItem from './MenuItem';
import List from './List';
import { Tooltip } from './Tooltip';
import { MenuSectionHeading } from './MenuSectionHeading';
import { MenuDivider } from './MenuDivider';
import { PlaceholderText } from './PlaceholderText';

export { default as Popover } from './Popover';
export * from './Popover';

export { default as InlinePlaceholder } from './InlinePlaceholder';
export * from './InlinePlaceholder';

export { default as BlockPlaceholder } from './BlockPlaceholder';
export * from './BlockPlaceholder';

export { default as VoidBlock } from './VoidBlock';
export * from './VoidBlock';

export { default as Button } from './Button';
export * from './Button';

export { default as List } from './List';
export * from './List';

export { default as MenuItem } from './MenuItem';
export * from './MenuItem';

export { default as TextField } from './TextField';
export * from './TextField';

export * from './Tooltip';
export * from './MenuSectionHeading';
export * from './PlaceholderText';
export * from './MenuDivider';

const components: UIComponents = {
  InlinePlaceholder,
  BlockPlaceholder,
  VoidBlock,
  Button,
  Popover,
  List,
  MenuItem,
  TextField,
  Tooltip,
  MenuSectionHeading,
  MenuDivider,
  PlaceholderText,
};

export default components;
